<template>
  <div class="d-flex align-center justify-start my-2">
    <p class="mb-1">{{ $t('message', { type: currentModule }) }}</p>
    <v-chip v-bind:key="channel.id" class="channel-chip ml-2 mt-n1" v-for="channel in currentChannels"
            :color="`#${$store.state.clubMember.club.primaryColor}`" @click="channelChanged(channel)"
            :text-color="`${(selectedChannel === channel.name)? '#FFFFFF' : '#111111'}`"
            :outlined="selectedChannel !== channel.name" v-text="channel.name"/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "ChannelSelect",
  props: {
    currentModule: String,
  },
  data() {
    return {
      selectedChannel: 'GENERAL',
      currentChannels: [],
    };
  },
  watch: {
    '$store.state.clubChannelsContributedByMe': function () {
      this.refreshList();
    },
    '$store.state.clubPublicChannels': function () {
      this.refreshList();
    },
  },
  mounted() {
    this.getCurrentChannel();
    this.refreshList();
  },
  methods: {
    getCurrentChannel() {
      this.selectedChannel = this.$store.state.currentClubChannel.name;
    },
    refreshList() {
      this.currentChannels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((contribution) => {
        this.currentChannels.push(contribution.clubChannel);
      });
      this.currentChannels.push.apply(this.currentChannels, this.$store.state.clubPublicChannels);
    },
    ...mapMutations(['setCurrentClubChannel']),
    channelChanged(channelContributor) {
      this.selectedChannel = channelContributor.name;
      this.setCurrentClubChannel(channelContributor);
    },
  },
}
</script>

<style scoped>
  .channel-chip {
    font-size: 14px !important;
  }
</style>

<i18n>
{
  "en":{
    "message": "Visualizing {type} from"
  },
  "es":{
    "message": "Visualizando {type} de"
  }
}
</i18n>
